module.exports = __webpack_public_path__ + "/bundle/asset/revision1-0c52cc09d4ff5ab6ede413c45b1e5acc.png";